import React from "react";
import home1 from "../img/home1.jpg";

//Styles
import styled from "styled-components";
import { About, Description, Image, Hide } from "../Styles";

import { motion } from "framer-motion";
import { titleAnim, fade, photoAnim } from "../animation";
import { Link } from "react-router-dom";

const aboutSection = () => {
  return (
    <About>
      <Description>
        <motion.div>
          <Hide>
            <motion.h2 variants={titleAnim}>We Make your</motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>
              Dream <span>come</span>
            </motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>True</motion.h2>
          </Hide>
        </motion.div>
        <motion.p variants={fade}>
          Contact us for any artificial intelligence or web dvelopment job ideas
          you have
        </motion.p>
        <Link to="/contact">
          <motion.button variants={fade}>Contact us</motion.button>
        </Link>
      </Description>
      <Image>
        <motion.img variants={photoAnim} src={home1} alt="" />
      </Image>
    </About>
  );
};

///Styled Components

export default aboutSection;
